var _ = require('underscore');
var DataBehavior = require('backbone-torso/modules/behaviors/DataBehavior');
var demographicsCollection = require('./demographicsCollection');

/**
 * Data Behavior hooked up to the demographics cache.
 * @class DemographicsDataBehavior
 * @constructor
 */
module.exports = DataBehavior.extend({
  cache: demographicsCollection,

  /**
   * This method attempts to take the event and state based fetch status of demographics data behavior and convert it into
   * a promise that can be used in a promise chain.
   * @method getDemographicsFetchedPromise
   * @return {jQuery.Promise} a promise that resolves with the fetch result once the demographics have been fetched.
   *                          If the fetch was a success then it resolves.
   *                          If the fetch failed then it rejects.
   */
  getDemographicsFetchedPromise: function() {
    var demographicsFetchedDeferred = $.Deferred();

    var demographicFetchSuccess = this.get('fetchSuccess');
    if (_.isUndefined(demographicFetchSuccess)) {
      this.view.listenToOnce(this, 'fetched', function() {
        var demographicFetchSuccess = this.get('fetchSuccess');
        if (demographicFetchSuccess) {
          demographicsFetchedDeferred.resolve(demographicFetchSuccess);
        } else {
          demographicsFetchedDeferred.reject(demographicFetchSuccess);
        }
      });
    } else {
      if (demographicFetchSuccess) {
        demographicsFetchedDeferred.resolve(demographicFetchSuccess);
      } else {
        demographicsFetchedDeferred.reject(demographicFetchSuccess);
      }
    }
    return demographicsFetchedDeferred.promise();
  }
});
